<script setup lang="ts">
import FormComodidade from '../components/form-comodidade.vue'
import { useComodidadeStore } from '../store/useComodidadeStore'

definePage({
  meta: {
    navActiveLink: 'admin-comodidade',
    action: 'create',
    subject: 'comodidade',
  },
})

const { resetForm } = useComodidadeStore()

onBeforeRouteLeave(() => {
  resetForm()
})
</script>

<template>
  <FormComodidade />
</template>
